<template>
  <div id="modal_popup_game_details" class="modal-popup">
    <div class="modal-popup-content">
      <a @click="showModalPopup('modal_popup_game_details', false)" class="close-button">
        <img src="@/assets/images/close-button.svg" />
      </a>
      <div class="d-inline-block" v-if="this.game">
        <div class="offer-details-wrapper">
          <div  class="offer-preview-image" :style="{ 'background-image': `url(${this.gameImage()})` }"></div>

          <div class="contact-details-wrapper">
            <label>
              start: {{ this.game.start_date }}
            </label>
            <label>
              end: {{ this.game.end_date }}
            </label>
            <div class="offer-price">
              <a class="button-all button-yellow">
                <img src="@/assets/images/cms-mkt/upcoins.svg" />
                {{ (this.game.up_coins) }}
              </a>
            </div>
          </div>
          <h5 v-if="this.game.texts">{{ this.game.texts[0].title }}</h5>
          <p class="description" v-if="this.game.texts" v-html="this.game.texts[0].description"></p>
          <h5 v-if="this.game.texts">{{ this.game.texts[1].title }}</h5>
          <p class="description" v-if="this.game.texts" v-html="this.game.texts[1].description"></p>
          <div class="details-wrapper" v-if="this.game.status === 'N' || this.game.status === 'I'">
            <div class="row d-flex flex-row ">
              <a @click="approveGame()" class="button-all button-yellow" v-if="isUserAdmin(user)">
                {{ $t('cmsLang.approveLabel') }}

              </a>
              <a @click="editGameDetails()" class="edit">
                <img src="@/assets/images/cms-mkt/edit.svg" />
              </a>
              <a @click="deleteGame()" class="delete">
                <img src="@/assets/images/cms-mkt/delete.svg" />
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/plugins/utils.js";

export default {
  name: "GameDetailsPopup",

  props: {
    user: Object,
    game: Object,
    image: String,
    gameType: String,
    currency: String,
  },
  data() {
    return {
      // offer: null,
    };
  },
  methods: {
    editGameDetails() {
      this.$emit("edit", this.game);
    },
    deleteGame() {
      this.$emit("delete", this.game);
    },
    approveGame() {
      this.$emit("approve", this.game);
    },
    gameImage() {
      if (this.game.image) {
        return "data:image/png;base64," + this.game.image
      } else {
        return require('@/assets/images/cms-mkt/offer_0.svg');
      }
    }

  },
  computed: {
  },
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
<style scoped>
.position {
  position: relative;
  left: 227px;
}

.contact-details-wrapper {
  justify-content: space-evenly;
}


label {
  width: 100%;
  border-radius: 9999px;
  border: 2px solid #fff;
  padding: 10px;
  margin: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  font-size: 14px;
  font-weight: lighter;
}

.offer-details-wrapper h5 {
  display: block;
}

.description {
  text-align: left;
}
</style>
